import { defineStore } from "pinia";

import { type IKundserviceAppApiClient } from "@/composables/KundserviceAppApiClient";

interface UserProfileState {
  initialized: boolean;
  isAuthorized: boolean;
  givenName: string;
  surname: string;
  email: string;
  acl: {
    [key: string]: boolean;
  };
  error: Error | null;
}

export const useUserProfileStore = defineStore("userProfile", {
  state: (): UserProfileState => ({
    initialized: false,
    isAuthorized: false,
    givenName: "",
    surname: "",
    email: "",
    acl: {},
    error: null,
  }),
  getters: {
    hasAnstalldAccess: (state: UserProfileState) => {
      return !!state.acl["Anstalld"];
    },
    hasAnstalldSkyddadIdentitetAccess: (state: UserProfileState) => {
      return !!state.acl["Anstalld.SkyddadIdentitet"];
    },
    hasArbetsgivareViewAccess: (state: UserProfileState) => {
      return !!state.acl["Arbetsgivare"];
    },
  },
  actions: {
    async init(apiClient: IKundserviceAppApiClient, forceRefresh = false) {
      if (this.initialized && !forceRefresh) {
        return;
      }

      this.error = null;
      const { givenName, surname, email, acl } = await apiClient.getMe();
      this.givenName = givenName ?? "";
      this.surname = surname ?? "";
      this.email = email ?? "";
      this.acl = acl ?? {};
      this.initialized = true;
    },
  },
});
